import { BANNER_SLOT_LOCATION } from '@/constants/banner';

export const SEARCH_CONTEXT = {
  SEARCH_AUTOCOMPLETE: 'search_autocomplete',
  SMT_SEARCH_AUTOCOMPLETE: 'smt_search_autocomplete',
  FREE_SEARCH: 'free_search',
  NAVIGATION: 'navigation',
  URL_ENTRY: 'url_entry',
  HOME_PAGE_CATEGORY: 'home_page_category',
  MEGA_MENU_CATEGORY: 'mega_menu_category',
  HOME_PAGE_FREE_SEARCH: 'home_page_free_search',
  HOME_PAGE_SEARCH_AUTOCOMPLETE: 'home_page_search_autocomplete',
  FOOTER_CATEGORY: 'footer_category',
  TOP_NAVIGATION_BAR: 'top_navigation_bar',
  BOTTOM_NAVIGATION_BAR: 'bottom_navigation_bar',
  DEALS_PREVIEW_SECTION: 'deals_preview_section',
  DEALS_KEYWORD_SHORTCUTS: 'deals_keyword_shortcuts',
  /**
   * temporary context from react-joyride spotlight
   */
  FEATURE_PROMOTION: 'feature_promotion_smt',
  DEALS_PROMOTION_CARD: 'deals_promotion_card',
  TAB: 'tab',
  ...BANNER_SLOT_LOCATION,
} as const;

export const SEARCH_FILTERS = {
  PAY_LATER: 'pay_later',
  GIFT_CARD: 'gift_card',
  WELLNESS_CARD: 'wellness_card',
  ASSOCIATIONS: 'associations',
  CAMPAIGNS: 'campaigns',
  BUNDLES: 'bundles',
} as const;

export const SORTED_BY = {
  POPULAR: 'popular',
  CLOSEST: 'closest',
  FIRST_AVAILABLE_TIME: 'first_available_time',
  HIGHEST_RATING: 'highest_rating',
  HIGHEST_DISCOUNT: 'highest_discount',
} as const;

export const CAMPAIGNS_SHOWN = {
  RAKETEN: 'raketen',
  SISTAMINUTEN: 'sistaminuten',
  DEALS: 'deals',
  BRAND_DEALS: 'brand_deals',
} as const;

export const SEARCH_LOCATION_FILTER = {
  GPS_LOCATION: 'gps_location',
  USER_INPUT: 'user_input',
} as const;

export const SEARCH_TIME_FILTER = {
  DEFAULT: 'default',
  USER_INPUT: 'user_input',
} as const;
